import React, { Component } from 'react'
import './ProjectComponent.css';

import {DefaultButton, PrimaryButton} from "office-ui-fabric-react";

import leftIcon from "../images/icons/chevron_left.svg";
import rightIcon from "../images/icons/chevron_right.svg";


function TechBubble(props)
{
    var colors = [
        "#d13438",
        "#da3b01",
        "#fce100",
        "#8cbd18",
        "#e3008c",
        "#0078d4",
        "#038387",
        "#0b6a0b",
        "#ca5010",
        "#393939",
        "#00b7c3"
    ];
    var style = {
        backgroundColor : colors[props.text.length % colors.length]
    }
    return (
        <div className = "techbubble" style = {style}>
            {props.text}
        </div>
    )
}



export default class ProjectComponent extends Component {
    constructor(props)
    {
        super(props);
        var that = this;
        
        if(!this.props.hold){
            this.state = {
                currentImage: that.props.img[0],
                currentImageIndex: 0
            }
    
            this.next.bind(this);
            this.prev.bind(this);
        }
    }

    componentDidMount()
    {
    }

    next()
    {
        var that = this;
        if((that.state.currentImageIndex + 1) === that.props.img.length)
        {
            this.setState({
                currentImage: that.props.img[0],
                currentImageIndex: 0
            })
        }
        else
        {
            this.setState({
                currentImage: that.props.img[that.state.currentImageIndex + 1],
                currentImageIndex: that.state.currentImageIndex += 1
            })
        }
    }

    prev()
    {
        var that = this;
        if((that.state.currentImageIndex) === 0)
        {
            this.setState({
                currentImage: that.props.img[that.props.img.length - 1],
                currentImageIndex: that.props.img.length - 1
            })
        }
        else
        {
            this.setState({
                currentImage: that.props.img[that.state.currentImageIndex - 1],
                currentImageIndex: that.state.currentImageIndex -= 1
            })
        }
    }

    render() {
        if(this.props.hold){
            return (
                <div className = "project-component-hold">
                </div>
            )
        } else {
            var that = this;
            var techStack = that.props.tech.map((tech, index) => {
                return(<TechBubble key = {tech} text = {tech} />)
            })
    
            var devPostButton = (that.props.devpost != null) && 
            (
            <div className = "project-component-links-button">
                <DefaultButton 
                text = {"DevPost"}
                onClick = {() => {
                    window.open(that.props.devpost);
                }}/>
            </div>
            )
    
            var liveButton = (that.props.live != null) && (
                <div className = "project-component-links-button">
                    <DefaultButton
                    text = {"Live"}
                    onClick = {() => {
                        window.open(that.props.live);
                    }}/>
                </div>
            )
    
    
            return (
                <div className = "project-component">
                    <div className = "image-container">
                        <img className = "current-image" alt = "" src = {this.state.currentImage}></img>
                        <div className = "project-component-icon">
                            <img onClick = {() => {
                                that.prev();
                            }} alt = "" className = "prev" src = {leftIcon}></img>
                            <img onClick = {() => {
                                that.next();
                            }} className = "next" alt = "" src = {rightIcon}></img>
                        </div>
                    </div>
                    <div className = "project-component-desc">
                        <p style = {{fontSize: "1.2vw"}}>{this.props.title}</p>
                        <p style = {{height: "100px", fontSize: "0.65vw"}}>{this.props.desc}</p>
                        <div className = "project-component-tech-stack">
                            {techStack}
                        </div>
                    </div>
                    <div className = "project-component-links">
                        <div className = "project-component-links-button">
                            <PrimaryButton
                                text = {"Github"}
                                onClick = { () => {
                                    if(that.props.github != null) window.open(that.props.github)
                                }}/>
                        </div>
                        {devPostButton}
                        {liveButton}
                    </div>
                </div>
            )
        }

    }
}
